import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { loadingStyles } from "./LoadingButton.styles.js";
import { Button } from "../Button/Button.js";
import { CircularProgress } from "../CircularProgress/CircularProgress.js";
const LoadingButton = ({
  loading,
  loaderProps,
  disabled = !!loading,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(Button, { "aria-busy": loading, disabled, css: loading && loadingStyles, ...props, children: [
    loading && /* @__PURE__ */ jsx(CircularProgress, { disableShrink: true, size: 16, ...loaderProps }),
    /* @__PURE__ */ jsx("span", { className: "Sunbeam-LoadingButton-content", children: props.children })
  ] });
};
export {
  LoadingButton
};
//# sourceMappingURL=LoadingButton.js.map
